import { render, staticRenderFns } from "./OwnerHasDamagesOnTenantPropertiesQuestion.vue?vue&type=template&id=273e185a&scoped=true"
import script from "./OwnerHasDamagesOnTenantPropertiesQuestion.vue?vue&type=script&lang=ts"
export * from "./OwnerHasDamagesOnTenantPropertiesQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e185a",
  null
  
)

export default component.exports